import {
  HttpRequest,
  HttpEvent,
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { ToastService } from '../../components/toast/toast.service';

export const hideToastUrls = ['/v1/provider/authentication/login'];

export const apiErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const toastService = inject(ToastService); // Using inject() for DI
  let isHideToast = hideToastUrls.some(url => req.url.includes(url));

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Check if the error response has the expected structure
      if (error.error?.Message) {
        const errorMessage = error.error.Message;
        if (!isHideToast) {
          toastService.showError(errorMessage); // Show the error message using ToastService
        }
      } else if (error.status == 401) {
        localStorage.setItem('currentUser', '');
      } else if (!isHideToast) {
        // Fallback for unexpected error structure
        toastService.showError('An unexpected error occurred.');
      }
      return throwError(() => error);
    }),
  );
};
